import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    Enums,
    errorRedirect,
    IDisposable,
    inject,
    Loader,
    ModalHandle,
    TasksStore,
    Tooltip,
} from 'Mri.Web.Common';
import * as React from 'react';
import { BsArrowClockwise } from '@react-icons/all-files/bs/BsArrowClockwise';
import { BsChevronDoubleUp } from '@react-icons/all-files/bs/BsChevronDoubleUp';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import {
    Button,
    ButtonGroup,
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledButtonDropdown,
} from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { AppStore } from '../Core/AppStore';
import { DisplaysStore } from '../Displays/DisplaysStore';
import { ManifestsStore } from './ManifestsStore';
import { LinkedManifestModal } from './LinkedManifestModal';
import { IUnitMeta } from './ManifestStatus';
import { ManifestDisplayItem } from './ManifestDisplayItem';

export interface IManifestUnitItemProps {
    readonly unit: IUnitMeta;
    readonly manifestGuid: string;
}

@autoinject
@observer
export class ManifestUnitItem extends React.Component<IManifestUnitItemProps> {
    public render() {
        const { unit } = this.props;
        return (
            <div className="col-12">
                <div className="px-2">
                    <small>Unit: {unit.unitSerialNumber}</small>
                    {unit.displays.map(d => (
                        <ManifestDisplayItem
                            display={d}
                            softwareUpdateManifestGuid={this.props.manifestGuid}
                            key={d.serialNumber}
                        />
                    ))}
                </div>
            </div>
        );
    }

    @bind
    public getErrorMessage(error: any) {
        return typeof error == 'string'
            ? error
            : typeof error == 'object' && typeof error.message == 'string'
                ? error.message
                : typeof error == 'object' && typeof error.Message == 'string'
                    ? error.Message
                    : 'An error has occured. Please try again.';
    }
}
